/*

    Mobile menu scripts

*/
  
// Menu
jQuery('.mobMenuBtn').on('click', function()
{
	jQuery('.mobMenu').toggleClass('open');
	jQuery('body').toggleClass('noScroll');
});

jQuery('.mobClose').on('click', function()
{
	jQuery('.mobMenu').removeClass('open');
	jQuery('body').removeClass('noScroll');
});

// Dropdowns
jQuery('.mobMenu li .dropdown').on('click', function()
{
	jQuery(this).parent().find('ul').first().slideToggle();
	jQuery(this).toggleClass('open');
});



// WEBPACK FOOTER //
// ./assets/js/components/mobile-menu.js